/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { SolutionTemplate } from "@/components/landing/solution-template";
import { landscapingConfig } from "./landscaping-config";

export function LandscapingPageClient() {
  return <SolutionTemplate config={landscapingConfig} />;
}
